module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content background",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box_step"
  }, [_c('div', {
    staticClass: "item-step",
    class: [_vm.step === 1 || _vm.step === 2 ? 'active' : '']
  }, [_c('span', [_vm._v("1")])]), _c('span', {
    staticClass: "horizontal-line"
  }), _c('div', {
    staticClass: "item-step",
    class: [_vm.step === 2 ? 'active' : '']
  }, [_c('span', [_vm._v("2")])]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-pc-step",
    class: [_vm.step === 1 ? 'open' : '']
  }, [_c('div', {
    staticClass: "item-pc-title"
  }, [_vm._v("TẠO PC MỚI")]), _c('div', {
    staticClass: "item-pc-content"
  }, [_c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitStep && (_vm.key_pc_name.length === 0 || _vm.key_pc_exists || (_vm.key_pc_name.length > 0 && _vm.isCharactorPC)) ? 'error' : '']
  }, [_c('span', {
    staticClass: "characters",
    domProps: {
      "textContent": _vm._s(_vm.key_pc_name.length + '/' + _vm.maxCharacters)
    }
  }), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nhập tên PC")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key_pc_name),
      expression: "key_pc_name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "key_pc_name",
      "maxlength": "125",
      "placeholder": "Nhập",
      "maxlength": _vm.maxCharacters,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.key_pc_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key_pc_name = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.isSubmitStep && _vm.key_pc_name.length === 0) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng nhập tên PC")]) : _vm._e(), (_vm.isSubmitStep && _vm.key_pc_name.length > 0 && _vm.isCharactorPC) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Tên PC không được nhập ký tự đặc biệt như !@#$%^&*()/\\{}?`|[]")]) : _vm._e(), (_vm.isSubmitStep && _vm.key_pc_exists) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Tên PC đã tồn tại")]) : _vm._e()]), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitStep && (_vm.key_pc_subjects.length === 0 || _vm.key_pc_subjects === 0) ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Môn học")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key_pc_subjects),
      expression: "key_pc_subjects",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "key_pc_subjects"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.key_pc_subjects = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": "0"
    },
    domProps: {
      "selected": _vm.key_pc_subjects === 0
    }
  }, [_vm._v("Chọn môn học")]), _vm._l((_vm.subjects), function(o) {
    return (!_vm.lstAllPCs.includes(o.id)) ? _c('option', {
      domProps: {
        "value": o.id,
        "selected": _vm.key_pc_subjects === o.id
      }
    }, [_vm._v(_vm._s(o.name))]) : _vm._e()
  })], 2), _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng chọn môn học bạn muốn tạo PC")])]), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitStep && (_vm.key_pc_id.length === 0 || _vm.siteExists > 0 || _vm.isCharactor) ? 'error' : '']
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("ID của trang")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.key_pc_id),
      expression: "key_pc_id",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "125",
      "name": "key_pc_id",
      "placeholder": "Example",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.key_pc_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.key_pc_id = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.key_pc_id.length === 0) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng nhập ID trang tối đa 125 ký tự")]) : _vm._e(), (_vm.key_pc_id.length > 0 && _vm.isCharactor) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("ID trang chỉ chứa các ký tự a-z và 0-9 hoặc dấu .-+_ ")]) : _vm._e(), (_vm.key_pc_id.length > 0 && _vm.siteExists > 0) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("ID trang đã tồn tại trong hệ thống")]) : _vm._e()]), _c('div', {
    staticClass: "note"
  }, [_c('span', [_vm._v("ID trang sau khi tạo sẽ không được chỉnh sửa. Trang của bạn sẽ được hiển thị như sau: ")]), _c('span', {
    staticClass: "link"
  }, [_c('strong', {
    staticClass: "domain"
  }, [_vm._v(_vm._s(_vm.domain))]), (_vm.key_pc_id.length) ? _c('b', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.key_pc_id) + "/")]) : _vm._e()])])]), _c('div', {
    staticClass: "item-pc-bottom"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Thêm yêu cầu mới")]), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/general"
    }
  }, [_vm._v("Huỷ yêu cầu")])], 1)])]), _c('div', {
    staticClass: "box-pc-step",
    class: [_vm.step === 2 ? 'open' : '']
  }, [_c('div', {
    staticClass: "item-pc-title"
  }, [_vm._v("Nội dung hiển thị")]), _c('div', {
    staticClass: "item-pc-content"
  }, [_c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && (_vm.$mycontroller.stripHtml(_vm.key_pc_content).length === 0 || _vm.isMaxAllow || _vm.isMinAllow) ? 'error' : '']
  }, [_c('span', {
    staticClass: "characters italic",
    domProps: {
      "textContent": _vm._s(_vm.numberWithCommas(_vm.$mycontroller.stripHtml(_vm.key_pc_content).length) + '/' + _vm.numberWithCommas(_vm.maxCharactersContent) + ' ký tự')
    }
  }), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Giới thiệu ngắn về cộng đồng của bạn")]), _c('froala', {
    attrs: {
      "id": "editor",
      "tag": 'textarea',
      "config": _vm.config,
      "autofocus": "autofocus"
    },
    on: {
      "input": _vm.changeContent
    },
    model: {
      value: (_vm.key_pc_content),
      callback: function($$v) {
        _vm.key_pc_content = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "key_pc_content"
    }
  }), (_vm.isMaxAllow) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng nhập tối đa 1000 ký tự")]) : _vm._e(), (_vm.isMinAllow) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Nhập tối thiểu 100 ký tự")]) : _vm._e()], 1), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && _vm.lstIcons.length === 0 ? 'error' : '']
  }, [_c('div', {
    staticClass: "box-icon"
  }, [_vm._m(0), _c('div', {
    attrs: {
      "id": "list_icon"
    }
  }, [_c('div', {
    staticClass: "box-button"
  }, [_c('div', {
    staticClass: "item-button"
  }, [_c('input', {
    attrs: {
      "id": "icon",
      "name": "icon",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onIconChange
    }
  }), _c('span', [_vm._v("Tải ảnh lên")])]), _c('div', {
    staticClass: "item-button"
  }, [_c('span', {
    on: {
      "click": _vm.openLibrary
    }
  }, [_vm._v("Chọn từ thư viện")])])]), _c('div', {
    staticClass: "box-item-icon"
  }, [_vm._l((_vm.lstIcons), function(icon, index) {
    return (icon) ? _c('div', {
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "material-icons remove",
      on: {
        "click": function($event) {
          return _vm.deleteIcon(index)
        }
      }
    }, [_vm._v("cancel")]), _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": icon.src
      }
    })]) : _vm._e()
  }), _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng upload ảnh icon cộng đồng của bạn")]), _c('div', {
    staticClass: "clearfix"
  })], 2), _c('div', {
    staticClass: "clearfix"
  })])])]), _c('div', {
    staticClass: "form-group",
    class: [_vm.isSubmitFinish && (_vm.lstBanners.length === 0 || _vm.lstBanners.length > 5) ? 'error' : '']
  }, [_c('div', {
    staticClass: "box-images"
  }, [_vm._m(1), _c('div', {
    attrs: {
      "id": "list_banner"
    }
  }, [_vm._l((_vm.lstBanners), function(banner, index) {
    return (banner) ? _c('div', {
      staticClass: "box-item"
    }, [_c('span', {
      staticClass: "material-icons remove",
      on: {
        "click": function($event) {
          return _vm.deleteBanner(index)
        }
      }
    }, [_vm._v("cancel")]), _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": banner.src
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "box-item last"
  }, [_c('input', {
    attrs: {
      "id": "banner",
      "name": "banner",
      "type": "file",
      "accept": "image/*",
      "multiple": "multiple"
    },
    on: {
      "change": _vm.onImageChange
    }
  }), _vm._m(2)]), _c('div', {
    staticClass: "clearfix"
  }), (_vm.lstBanners.length === 0) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng upload ảnh banner cộng đồng của bạn")]) : _vm._e(), (_vm.lstBanners.length > 0 && _vm.lstBanners.length > 5) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("Vui lòng upload ảnh tối đa 5 ảnh")]) : _vm._e()], 2), _c('div', {
    staticClass: "clearfix"
  })])])]), _c('div', {
    staticClass: "item-pc-bottom"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.finishPC()
      }
    }
  }, [_vm._v("Hoàn thành")]), _c('button', {
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_vm._v("Quay lại")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('strong', [_vm._v("Icon cộng đồng: "), _c('span', [_vm._v("(Kích thước đề nghị: 300x300 px)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label"
  }, [_c('strong', [_vm._v("Ảnh banner của cộng đồng: "), _c('span', [_vm._v("(Kích thước đề nghị: 1600x900 px)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "material-icons list-action"
  }, [_vm._v("add")]), _c('strong', [_vm._v("Tải ảnh lên")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e313faac","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PC/step.vue
// module id = 1657
// module chunks = 0